export const ROUTE_GENERATE_PREVIEW_BOOK = '/generate-preview-book';
